import type { Distance } from '$lib/components/types';

export const ONE_FOOT_IN_METERS = 0.3048;
export const ONE_MILE_IN_METERS = 1609.344;
export const ONE_KILOMETER_IN_METERS = 1000;

export function convertDistanceUnitsToMeters(distance: Distance | undefined): number | undefined {
	if (!distance) return undefined;
	const { value, unit } = distance;

	switch (unit) {
		case 'KILOMETER':
			return value * ONE_KILOMETER_IN_METERS;
		case 'FOOT':
			return value * ONE_FOOT_IN_METERS;
		case 'MILE':
			return value * ONE_MILE_IN_METERS;
		default:
			return value;
	}
}
